import React from 'react'
import Regions from '../components/Regions'
import DashboardBlog from './DashboardBlog'
import Footer from '../components/Footer'

const Bolgeler = () => {
  return (
    <> 
    <DashboardBlog />
    <Regions />
    <Footer />
    </>
  )
}

export default Bolgeler